import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useGetCurrentMemberAccount } from 'src/hooks/accounts/get-current-member-account.hook';

import { GET_SUPPORT_REQUESTS } from './get-support-requests.hook';
import { ALLOWED_SUPPORT_REQUEST_CREATION } from './allowed-support-request-creation.hook';

export const CREATE_SUPPORT_REQUEST = gql`
  mutation ($payload: CreateSupportRequestInput!) {
    createSupportRequest(payload: $payload) {
      _id
    }
  }
`;

export const useCreateSupportRequest = () => {
  const { t } = useTranslation(['supportRequests', 'common']);
  const { t: globalExceptionsT } = useTranslation('common', { keyPrefix: 'exceptions' });
  const currentCompanyId = useGetCurrentCompanyId();
  const { member } = useGetCurrentMemberAccount();

  const [createSupportRequest] = useMutation(CREATE_SUPPORT_REQUEST, {
    refetchQueries: [GET_SUPPORT_REQUESTS, ALLOWED_SUPPORT_REQUEST_CREATION],
    onCompleted: () => {
      showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.success,
        message: t('supportRequests:notifications.success.added'),
      });
    },
    onError: (error: any) =>
      showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: globalExceptionsT('internalError'),
        ...(error && { description: error.errorMessage }),
      }),
  });

  return (request: any) =>
    createSupportRequest({
      variables: {
        payload: {
          ...request,
          memberId: member._id,
          companyId: currentCompanyId,
        },
      },
    });
};
